export default {
  unknown: 'Невідомо',
};
